/* eslint-disable no-undef */
const getBounds = (polygon) => {
  const bounds = new google.maps.LatLngBounds()
  polygon.getPath().forEach((element) => {
    bounds.extend(element)
  })
  return bounds
}

export default getBounds
